export default __webpack_public_path__ + "static/media/spectrum.7c8c6840.png";